const e = {
  "stage-home-teaser": "stage-home-teaser",
  "stage-home-teaser__title": "stage-home-teaser__title",
  "stage-home-teaser__description": "stage-home-teaser__description",
  "stage-home-teaser__button-wrapper": "stage-home-teaser__button-wrapper"
};
export {
  e as default
};
